import { CompactText } from 'ui/CompactText';
import type { FC } from 'react';
import { PageHead } from 'ui/kit/PageHead';
import { Link } from 'react-router';

import { FadeIn } from 'ui/kit/uiMotion';

import classes from './StudentProfileView.module.scss';
import { studentParticipantLabel } from './studentProfileScreen';
import type { IProfile } from '../model/types';

type Props = {
  profile: IProfile;
  onView: () => void;
};

export const StudentProfilePending: FC<Props> = ({ profile, onView }) => (
  <FadeIn>
    <main className={classes.page}>
      <PageHead crumb={<>Личный кабинет / Мой профиль</>} title={<>Профиль на проверке</>} />

      <section className={classes.card}>
        <h2 className={classes.cardTitle}>Изменения отправлены на проверку</h2>
        <span className={classes.chip}>
          <span className={classes.chipDot} aria-hidden />
          На проверке
        </span>
        <p className={classes.body}>
          Имя и данные сохранены. Проверка еще не завершена. Это не оценка тебя.
        </p>

        <div className={classes.row}>
          <div className={classes.cell}>
            <p className={classes.label}>Имя</p>
            <p className={classes.value}>{profile.name || ' - '}</p>
          </div>
          <div className={classes.cell}>
            <p className={classes.label}>Участник</p>
            <p className={classes.value}>{studentParticipantLabel(profile.registrant_type)}</p>
          </div>
        </div>

        <CompactText className={classes.hint} tone={'info'}>
          Можно работать с задачами. Результат проверки появится в уведомлениях.
        </CompactText>

        <div className={classes.actions}>
          <button type="button" className={classes.primary} onClick={onView}>
            Посмотреть профиль
          </button>
          <Link to="/profile/tasks" className={classes.secondary}>
            К моим задачам
          </Link>
        </div>
      </section>
    </main>
  </FadeIn>
);
